import sweetFactoryStoreLogo from '@rewardopl/assets/logos/sweetfactorystore.svg';

import { Image, Wrapper } from './vendor_logo.styles';

import { VENDOR_BUSINESS_NAME } from '../../constants';

type VendorLogoProps = { width?: number };

export default function VendorLogo({ width = 180 }: VendorLogoProps) {
  const height = width;

  return (
    <Wrapper>
      <Image width={width} height={height} src={sweetFactoryStoreLogo} alt={VENDOR_BUSINESS_NAME} />
    </Wrapper>
  );
}
